const Laurie = () => {
  return (
    <div className='w-1/5 h-20 flex justify-center items-center sm:w-1/4 md:w-[15%] xl:w-1/5'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 120 120'
        width='100%'
        height='100%'
      >
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#000000'
          strokeOpacity='0.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 0.00 59.00 
C 20.00 39.83 39.88 19.95 59.00 0.00
L 0.00 0.00
L 0.00 59.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#FFFFFF'
          strokeOpacity='0.50'
          strokeWidth='0.3'
        >
          <path
            d='
M 0.00 59.00 
L 0.00 61.00
C 20.00 80.17 39.88 100.05 59.00 120.00
L 61.00 120.00
C 80.17 100.00 100.05 80.12 120.00 61.00
L 120.00 59.00
C 100.00 39.83 80.12 19.95 61.00 0.00
L 59.00 0.00
C 39.88 19.95 20.00 39.83 0.00 59.00
M 61.00 1.00 
C 79.84 20.67 99.38 40.21 119.00 59.00
C 101.74 80.08 79.39 98.45 61.00 119.00
C 39.92 101.74 21.55 79.39 1.00 61.00
C 19.19 40.31 40.33 19.17 61.00 1.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#000000'
          strokeOpacity='0.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 120.00 59.00 
L 120.00 0.00
L 61.00 0.00
C 80.12 19.95 100.00 39.83 120.00 59.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#F9F9F9'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 61.00 1.00 
C 40.33 19.17 19.19 40.31 1.00 61.00
C 21.55 79.39 39.92 101.74 61.00 119.00
C 79.39 98.45 101.74 80.08 119.00 59.00
C 99.38 40.21 79.84 20.67 61.00 1.00
M 73.00 22.00 
C 73.78 22.74 74.95 23.01 76.00 23.00
C 76.27 24.28 75.23 25.72 74.00 26.00
C 70.27 31.03 64.33 34.54 61.00 40.00
C 60.93 40.12 59.79 41.93 60.00 42.00
C 62.29 43.11 65.05 47.70 66.75 50.25 C 68.45 52.80 72.10 56.55 74.00 59.00
C 75.58 61.04 76.14 59.34 74.00 62.00
C 69.87 67.15 62.96 70.94 60.00 77.00
C 59.80 77.40 60.00 78.00 60.00 78.00
C 65.02 75.54 75.16 66.09 77.00 61.00
C 77.16 60.56 77.00 60.00 77.00 60.00
C 77.00 59.50 77.00 59.00 77.00 59.00
C 78.36 49.96 60.36 46.76 62.00 41.00
C 62.86 37.99 67.81 34.87 70.00 33.00
C 72.79 30.62 77.19 28.05 77.00 24.00
C 82.70 27.42 85.79 35.77 91.00 40.00
C 91.74 40.76 92.98 40.99 94.00 41.00
C 92.73 45.13 88.18 48.20 85.00 51.00
C 84.29 51.94 83.68 53.10 83.00 54.00
C 82.08 55.23 81.04 56.98 80.00 58.00
C 85.17 52.46 91.95 46.64 97.00 42.00
C 100.38 48.08 104.96 54.32 110.00 59.00
C 112.01 61.30 111.74 58.71 110.00 61.00
C 107.52 64.27 104.50 66.63 101.75 69.75 C 99.00 72.87 96.72 78.15 94.00 76.00
C 91.49 74.02 87.79 67.50 84.00 64.00
C 82.28 62.75 80.59 61.02 79.00 60.00
C 78.60 60.20 78.00 60.00 78.00 60.00
C 78.81 60.73 79.38 62.16 80.00 63.00
C 84.01 68.45 87.91 74.83 94.00 78.00
C 93.04 79.57 91.68 81.25 90.00 82.00
C 88.46 83.54 86.42 85.47 85.00 87.00
C 82.44 90.24 80.46 93.62 77.00 96.00
C 76.78 96.15 75.70 97.73 75.00 97.00
C 68.30 101.68 64.23 109.86 58.00 114.00
C 63.78 104.38 43.98 103.29 43.25 96.75 C 42.51 90.22 58.74 84.80 59.00 78.00
C 58.50 78.00 58.00 78.00 58.00 78.00
C 57.82 79.15 56.72 79.45 56.00 80.00
C 49.90 84.66 45.78 92.01 40.00 96.00
C 43.42 85.84 27.13 85.28 25.00 77.00
C 30.47 71.74 37.54 66.54 41.00 60.00
C 40.50 60.00 40.00 60.00 40.00 60.00
C 39.82 61.15 38.72 61.45 38.00 62.00
C 34.83 64.42 31.93 67.18 29.25 70.25 C 26.57 73.31 24.70 78.13 22.00 76.00
C 20.03 74.44 16.91 69.15 14.00 66.00
C 11.44 64.10 9.34 61.21 6.00 61.00
C 8.44 57.28 13.25 53.23 17.00 50.00
C 18.65 48.35 20.30 46.54 22.00 45.00
C 22.39 44.57 22.27 42.49 23.00 42.00
C 28.62 45.84 30.67 53.03 36.00 57.00
C 36.38 57.30 38.42 58.16 38.00 59.00
C 38.50 59.00 39.58 59.18 40.00 59.00
C 40.03 58.65 40.71 57.94 41.00 58.00
C 40.15 52.05 33.41 49.28 29.00 46.00
C 27.79 45.10 26.56 44.48 26.00 43.00
C 25.17 40.82 38.28 28.34 41.00 25.00
C 41.80 24.02 42.09 24.65 43.00 24.00
C 49.45 19.39 55.03 11.53 60.00 6.00
C 64.01 11.53 67.71 17.62 73.00 22.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#4B51A2'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 43.00 24.00 
C 44.55 24.27 45.89 27.09 47.00 28.00
C 52.93 31.61 55.22 35.23 59.00 40.00
C 59.27 39.94 59.90 40.75 61.00 40.00
C 64.33 34.54 70.27 31.03 74.00 26.00
C 71.26 28.47 61.97 29.99 59.00 35.00
C 59.00 28.67 59.00 22.33 59.00 16.00
C 63.84 16.88 68.18 24.41 73.00 22.00
C 67.71 17.62 64.01 11.53 60.00 6.00
C 55.03 11.53 49.45 19.39 43.00 24.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#9599CC'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 74.00 26.00 
C 75.23 25.72 76.27 24.28 76.00 23.00
C 74.95 23.01 73.78 22.74 73.00 22.00
C 68.18 24.41 63.84 16.88 59.00 16.00
C 59.00 22.33 59.00 28.67 59.00 35.00
C 61.97 29.99 71.26 28.47 74.00 26.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#A0A4CE'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 41.00 25.00 
C 40.96 25.24 43.79 26.80 44.00 27.00
C 43.91 26.96 46.05 27.42 47.00 28.00
C 45.89 27.09 44.55 24.27 43.00 24.00
C 42.09 24.65 41.80 24.02 41.00 25.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#4B52A3'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 70.00 33.00 
C 68.37 34.63 62.71 39.18 62.00 41.00
C 60.36 46.76 78.36 49.96 77.00 59.00
C 78.93 57.65 81.47 55.67 83.00 54.00
C 83.68 53.10 84.29 51.94 85.00 51.00
C 86.56 48.93 88.62 47.13 90.00 45.00
C 85.54 46.18 81.77 49.33 78.00 52.00
C 78.00 46.00 78.00 40.00 78.00 34.00
C 81.94 36.46 86.81 41.25 91.00 40.00
C 85.79 35.77 82.70 27.42 77.00 24.00
C 77.19 28.05 72.79 30.62 70.00 33.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#484FA1'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 26.00 43.00 
C 26.23 43.44 28.58 45.62 29.00 46.00
C 33.41 49.28 40.15 52.05 41.00 58.00
C 41.05 58.35 41.88 58.74 42.00 59.00
C 44.33 54.23 50.72 48.04 55.00 45.00
C 51.44 46.37 44.63 48.67 41.00 53.00
C 41.00 46.67 41.00 40.33 41.00 34.00
C 45.84 34.88 50.18 42.41 55.00 40.00
C 50.02 37.12 48.01 30.78 44.00 27.00
C 43.79 26.80 40.96 25.24 41.00 25.00
C 38.28 28.34 25.17 40.82 26.00 43.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#E8E9F4'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 44.00 27.00 
C 48.01 30.78 50.02 37.12 55.00 40.00
C 58.53 40.47 55.82 40.77 59.00 40.00
C 55.22 35.23 52.93 31.61 47.00 28.00
C 46.05 27.42 43.91 26.96 44.00 27.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#BFC2DF'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 62.00 41.00 
C 62.71 39.18 68.37 34.63 70.00 33.00
C 67.81 34.87 62.86 37.99 62.00 41.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#969ACC'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 55.00 45.00 
C 56.37 44.02 57.69 43.73 59.00 43.00
C 59.13 42.65 59.75 41.92 60.00 42.00
C 59.79 41.93 60.93 40.12 61.00 40.00
C 59.90 40.75 59.27 39.94 59.00 40.00
C 55.82 40.77 58.53 40.47 55.00 40.00
C 50.18 42.41 45.84 34.88 41.00 34.00
C 41.00 40.33 41.00 46.67 41.00 53.00
C 44.63 48.67 51.44 46.37 55.00 45.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#979BCC'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 85.00 51.00 
C 88.18 48.20 92.73 45.13 94.00 41.00
C 92.98 40.99 91.74 40.76 91.00 40.00
C 86.81 41.25 81.94 36.46 78.00 34.00
C 78.00 40.00 78.00 46.00 78.00 52.00
C 81.77 49.33 85.54 46.18 90.00 45.00
C 88.62 47.13 86.56 48.93 85.00 51.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#EE4726'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 22.00 45.00 
C 20.36 46.78 18.81 48.46 17.00 50.00
C 13.25 53.23 8.44 57.28 6.00 61.00
C 9.34 61.21 11.44 64.10 14.00 66.00
C 15.96 67.46 18.06 68.56 20.00 70.00
C 21.03 70.77 22.78 71.56 23.00 73.00
C 23.15 73.96 23.30 75.76 22.00 76.00
C 24.70 78.13 26.57 73.31 29.25 70.25 C 31.93 67.18 34.83 64.42 38.00 62.00
C 34.16 63.46 27.28 66.17 23.00 70.00
C 23.00 63.67 23.00 57.33 23.00 51.00
C 27.40 54.37 31.53 57.93 37.00 59.00
C 36.49 58.75 36.32 57.35 36.00 57.00
C 30.67 53.03 28.62 45.84 23.00 42.00
C 22.27 42.49 22.39 44.57 22.00 45.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#EE4725'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 59.00 43.00 
C 58.78 43.59 58.31 44.49 58.00 45.00
C 56.70 47.14 54.79 48.47 53.00 50.00
C 49.37 53.11 44.62 56.59 43.00 61.00
C 45.91 61.75 47.51 64.61 50.00 66.00
C 53.01 68.24 61.61 71.49 58.00 76.00
C 57.98 76.50 58.00 77.00 58.00 77.00
C 58.16 76.77 59.84 76.77 60.00 77.00
C 62.96 70.94 69.87 67.15 74.00 62.00
C 71.22 64.00 62.62 66.01 59.00 70.00
C 59.00 64.00 59.00 58.00 59.00 52.00
C 64.21 53.76 68.00 59.01 74.00 59.00
C 72.10 56.55 68.45 52.80 66.75 50.25 C 65.05 47.70 62.29 43.11 60.00 42.00
C 59.75 41.92 59.13 42.65 59.00 43.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#EE4927'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 80.00 58.00 
C 79.77 58.25 79.17 59.92 79.00 60.00
C 80.59 61.02 82.28 62.75 84.00 64.00
C 86.92 66.13 86.88 68.02 90.75 69.25 C 94.62 70.48 93.33 74.49 94.00 76.00
C 96.72 78.15 99.00 72.87 101.75 69.75 C 104.50 66.63 107.52 64.27 110.00 61.00
C 105.69 64.36 99.00 65.68 95.00 70.00
C 95.00 64.00 95.00 58.00 95.00 52.00
C 100.38 53.58 103.93 58.85 110.00 59.00
C 104.96 54.32 100.38 48.08 97.00 42.00
C 91.95 46.64 85.17 52.46 80.00 58.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#838EC6'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 29.00 46.00 
C 28.58 45.62 26.23 43.44 26.00 43.00
C 26.56 44.48 27.79 45.10 29.00 46.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#F2F3F1'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 55.00 45.00 
C 50.72 48.04 44.33 54.23 42.00 59.00
C 41.80 59.40 42.00 60.00 42.00 60.00
C 45.69 64.84 49.60 73.03 55.00 76.00
C 55.89 76.49 57.28 76.55 58.00 77.00
C 58.00 77.00 57.98 76.50 58.00 76.00
C 58.06 74.19 52.28 68.47 50.00 66.00
C 47.51 64.61 45.91 61.75 43.00 61.00
C 44.62 56.59 49.37 53.11 53.00 50.00
C 54.55 48.45 56.57 46.54 58.00 45.00
C 58.31 44.49 58.78 43.59 59.00 43.00
C 57.69 43.73 56.37 44.02 55.00 45.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#F6A45E'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 17.00 50.00 
C 18.81 48.46 20.36 46.78 22.00 45.00
C 20.30 46.54 18.65 48.35 17.00 50.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#F9B578'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 53.00 50.00 
C 54.79 48.47 56.70 47.14 58.00 45.00
C 56.57 46.54 54.55 48.45 53.00 50.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#F89D5D'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 38.00 62.00 
C 38.72 61.45 39.82 61.15 40.00 60.00
C 40.07 59.51 40.00 59.00 40.00 59.00
C 39.58 59.18 38.50 59.00 38.00 59.00
C 37.50 59.00 37.00 59.00 37.00 59.00
C 31.53 57.93 27.40 54.37 23.00 51.00
C 23.00 57.33 23.00 63.67 23.00 70.00
C 27.28 66.17 34.16 63.46 38.00 62.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#F79C5D'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 74.00 62.00 
C 76.14 59.34 75.58 61.04 74.00 59.00
C 68.00 59.01 64.21 53.76 59.00 52.00
C 59.00 58.00 59.00 64.00 59.00 70.00
C 62.62 66.01 71.22 64.00 74.00 62.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#F79C5D'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 110.00 61.00 
C 111.74 58.71 112.01 61.30 110.00 59.00
C 103.93 58.85 100.38 53.58 95.00 52.00
C 95.00 58.00 95.00 64.00 95.00 70.00
C 99.00 65.68 105.69 64.36 110.00 61.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#8FB0EB'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 77.00 59.00 
C 77.00 59.00 77.00 59.50 77.00 60.00
C 77.25 59.75 78.00 60.00 78.00 60.00
C 78.61 59.41 79.42 58.56 80.00 58.00
C 81.04 56.98 82.08 55.23 83.00 54.00
C 81.47 55.67 78.93 57.65 77.00 59.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#F7A6A0'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 37.00 59.00 
C 37.00 59.00 37.50 59.00 38.00 59.00
C 38.42 58.16 36.38 57.30 36.00 57.00
C 36.32 57.35 36.49 58.75 37.00 59.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#8F9DD8'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 40.00 59.00 
C 40.00 59.00 40.07 59.51 40.00 60.00
C 40.00 60.00 40.50 60.00 41.00 60.00
C 41.50 60.00 42.00 60.00 42.00 60.00
C 42.00 60.00 41.80 59.40 42.00 59.00
C 41.88 58.74 41.05 58.35 41.00 58.00
C 40.71 57.94 40.03 58.65 40.00 59.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#FFBDAA'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 78.00 60.00 
C 78.00 60.00 78.60 60.20 79.00 60.00
C 79.17 59.92 79.77 58.25 80.00 58.00
C 79.42 58.56 78.61 59.41 78.00 60.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#28AE4E'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 56.00 80.00 
C 52.18 81.41 45.48 84.56 41.00 88.00
C 41.00 82.00 41.00 76.00 41.00 70.00
C 45.84 70.88 50.18 78.41 55.00 76.00
C 49.60 73.03 45.69 64.84 42.00 60.00
C 42.00 60.00 41.50 60.00 41.00 60.00
C 37.54 66.54 30.47 71.74 25.00 77.00
C 27.13 85.28 43.42 85.84 40.00 96.00
C 45.78 92.01 49.90 84.66 56.00 80.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#85DAA4'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 77.00 61.00 
C 77.74 61.81 79.25 62.29 80.00 63.00
C 79.38 62.16 78.81 60.73 78.00 60.00
C 78.00 60.00 77.25 59.75 77.00 60.00
C 77.00 60.00 77.16 60.56 77.00 61.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#000000'
          strokeOpacity='0.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 0.00 120.00 
L 59.00 120.00
C 39.88 100.05 20.00 80.17 0.00 61.00
L 0.00 120.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#2AAF4F'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 60.00 78.00 
C 59.60 78.20 59.00 78.00 59.00 78.00
C 58.74 84.80 42.51 90.22 43.25 96.75 C 43.98 103.29 63.78 104.38 58.00 114.00
C 64.23 109.86 68.30 101.68 75.00 97.00
C 75.23 96.84 75.00 96.00 75.00 96.00
C 69.10 97.65 64.59 103.66 59.00 106.00
C 59.00 100.00 59.00 94.00 59.00 88.00
C 63.84 88.88 68.18 96.41 73.00 94.00
C 68.66 90.68 65.38 85.61 63.00 81.00
C 67.99 83.88 72.22 87.82 77.00 91.00
C 77.27 92.60 74.57 94.99 77.00 96.00
C 80.46 93.62 82.44 90.24 85.00 87.00
C 86.55 85.04 88.17 83.56 90.00 82.00
C 91.68 81.25 93.04 79.57 94.00 78.00
C 87.91 74.83 84.01 68.45 80.00 63.00
C 79.25 62.29 77.74 61.81 77.00 61.00
C 75.16 66.09 65.02 75.54 60.00 78.00
M 92.00 78.00 
C 88.01 82.80 81.54 84.63 77.00 89.00
C 77.00 82.67 77.00 76.33 77.00 70.00
C 82.44 71.73 85.94 77.46 92.00 78.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#000000'
          strokeOpacity='0.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 61.00 120.00 
L 120.00 120.00
L 120.00 61.00
C 100.05 80.12 80.17 100.00 61.00 120.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#FCCFA4'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 94.00 76.00 
C 93.33 74.49 94.62 70.48 90.75 69.25 C 86.88 68.02 86.92 66.13 84.00 64.00
C 87.79 67.50 91.49 74.02 94.00 76.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#FCCFA3'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 22.00 76.00 
C 23.30 75.76 23.15 73.96 23.00 73.00
C 23.00 73.00 20.15 70.14 20.00 70.00
C 18.06 68.56 15.96 67.46 14.00 66.00
C 16.91 69.15 20.03 74.44 22.00 76.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#FCCEA2'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 58.00 76.00 
C 61.61 71.49 53.01 68.24 50.00 66.00
C 52.28 68.47 58.06 74.19 58.00 76.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#F79351'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 23.00 73.00 
C 22.78 71.56 21.03 70.77 20.00 70.00
C 20.15 70.14 23.00 73.00 23.00 73.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#96CC79'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 56.00 80.00 
C 56.72 79.45 57.82 79.15 58.00 78.00
C 58.07 77.51 58.00 77.00 58.00 77.00
C 57.28 76.55 55.89 76.49 55.00 76.00
C 50.18 78.41 45.84 70.88 41.00 70.00
C 41.00 76.00 41.00 82.00 41.00 88.00
C 45.48 84.56 52.18 81.41 56.00 80.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#96CC77'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 92.00 78.00 
C 85.94 77.46 82.44 71.73 77.00 70.00
C 77.00 76.33 77.00 82.67 77.00 89.00
C 81.54 84.63 88.01 82.80 92.00 78.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#FBAAA1'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 58.00 78.00 
C 58.00 78.00 58.50 78.00 59.00 78.00
C 59.00 78.00 59.60 78.20 60.00 78.00
C 60.00 78.00 59.80 77.40 60.00 77.00
C 59.84 76.77 58.16 76.77 58.00 77.00
C 58.00 77.00 58.07 77.51 58.00 78.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#E7F2DF'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 73.00 94.00 
C 73.80 94.61 74.82 94.82 75.00 96.00
C 75.00 96.00 75.23 96.84 75.00 97.00
C 75.70 97.73 76.78 96.15 77.00 96.00
C 74.57 94.99 77.27 92.60 77.00 91.00
C 72.22 87.82 67.99 83.88 63.00 81.00
C 65.38 85.61 68.66 90.68 73.00 94.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#9ADAAB'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 85.00 87.00 
C 86.42 85.47 88.46 83.54 90.00 82.00
C 88.17 83.56 86.55 85.04 85.00 87.00 Z'
          />
        </g>
        <g
          fill='None'
          fillOpacity='0.0'
          stroke='#96CC78'
          strokeOpacity='1.00'
          strokeWidth='0.3'
        >
          <path
            d='
M 75.00 96.00 
C 74.82 94.82 73.80 94.61 73.00 94.00
C 68.18 96.41 63.84 88.88 59.00 88.00
C 59.00 94.00 59.00 100.00 59.00 106.00
C 64.59 103.66 69.10 97.65 75.00 96.00 Z'
          />
        </g>
        <g fill='#000000' fillOpacity='0.00' stroke='None'>
          <path
            d='
M 0.00 59.00 
C 20.00 39.83 39.88 19.95 59.00 0.00
L 0.00 0.00
L 0.00 59.00 Z'
          />
        </g>
        <g fill='#FFFFFF' fillOpacity='0.50' stroke='None'>
          <path
            d='
M 0.00 59.00 
L 0.00 61.00
C 20.00 80.17 39.88 100.05 59.00 120.00
L 61.00 120.00
C 80.17 100.00 100.05 80.12 120.00 61.00
L 120.00 59.00
C 100.00 39.83 80.12 19.95 61.00 0.00
L 59.00 0.00
C 39.88 19.95 20.00 39.83 0.00 59.00
M 61.00 1.00 
C 79.84 20.67 99.38 40.21 119.00 59.00
C 101.74 80.08 79.39 98.45 61.00 119.00
C 39.92 101.74 21.55 79.39 1.00 61.00
C 19.19 40.31 40.33 19.17 61.00 1.00 Z'
          />
        </g>
        <g fill='#000000' fillOpacity='0.00' stroke='None'>
          <path
            d='
M 120.00 59.00 
L 120.00 0.00
L 61.00 0.00
C 80.12 19.95 100.00 39.83 120.00 59.00 Z'
          />
        </g>
        <g fill='#F9F9F9' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 61.00 1.00 
C 40.33 19.17 19.19 40.31 1.00 61.00
C 21.55 79.39 39.92 101.74 61.00 119.00
C 79.39 98.45 101.74 80.08 119.00 59.00
C 99.38 40.21 79.84 20.67 61.00 1.00
M 73.00 22.00 
C 73.78 22.74 74.95 23.01 76.00 23.00
C 76.27 24.28 75.23 25.72 74.00 26.00
C 70.27 31.03 64.33 34.54 61.00 40.00
C 60.93 40.12 59.79 41.93 60.00 42.00
C 62.29 43.11 65.05 47.70 66.75 50.25 C 68.45 52.80 72.10 56.55 74.00 59.00
C 75.58 61.04 76.14 59.34 74.00 62.00
C 69.87 67.15 62.96 70.94 60.00 77.00
C 59.80 77.40 60.00 78.00 60.00 78.00
C 65.02 75.54 75.16 66.09 77.00 61.00
C 77.16 60.56 77.00 60.00 77.00 60.00
C 77.00 59.50 77.00 59.00 77.00 59.00
C 78.36 49.96 60.36 46.76 62.00 41.00
C 62.86 37.99 67.81 34.87 70.00 33.00
C 72.79 30.62 77.19 28.05 77.00 24.00
C 82.70 27.42 85.79 35.77 91.00 40.00
C 91.74 40.76 92.98 40.99 94.00 41.00
C 92.73 45.13 88.18 48.20 85.00 51.00
C 84.29 51.94 83.68 53.10 83.00 54.00
C 82.08 55.23 81.04 56.98 80.00 58.00
C 85.17 52.46 91.95 46.64 97.00 42.00
C 100.38 48.08 104.96 54.32 110.00 59.00
C 112.01 61.30 111.74 58.71 110.00 61.00
C 107.52 64.27 104.50 66.63 101.75 69.75 C 99.00 72.87 96.72 78.15 94.00 76.00
C 91.49 74.02 87.79 67.50 84.00 64.00
C 82.28 62.75 80.59 61.02 79.00 60.00
C 78.60 60.20 78.00 60.00 78.00 60.00
C 78.81 60.73 79.38 62.16 80.00 63.00
C 84.01 68.45 87.91 74.83 94.00 78.00
C 93.04 79.57 91.68 81.25 90.00 82.00
C 88.46 83.54 86.42 85.47 85.00 87.00
C 82.44 90.24 80.46 93.62 77.00 96.00
C 76.78 96.15 75.70 97.73 75.00 97.00
C 68.30 101.68 64.23 109.86 58.00 114.00
C 63.78 104.38 43.98 103.29 43.25 96.75 C 42.51 90.22 58.74 84.80 59.00 78.00
C 58.50 78.00 58.00 78.00 58.00 78.00
C 57.82 79.15 56.72 79.45 56.00 80.00
C 49.90 84.66 45.78 92.01 40.00 96.00
C 43.42 85.84 27.13 85.28 25.00 77.00
C 30.47 71.74 37.54 66.54 41.00 60.00
C 40.50 60.00 40.00 60.00 40.00 60.00
C 39.82 61.15 38.72 61.45 38.00 62.00
C 34.83 64.42 31.93 67.18 29.25 70.25 C 26.57 73.31 24.70 78.13 22.00 76.00
C 20.03 74.44 16.91 69.15 14.00 66.00
C 11.44 64.10 9.34 61.21 6.00 61.00
C 8.44 57.28 13.25 53.23 17.00 50.00
C 18.65 48.35 20.30 46.54 22.00 45.00
C 22.39 44.57 22.27 42.49 23.00 42.00
C 28.62 45.84 30.67 53.03 36.00 57.00
C 36.38 57.30 38.42 58.16 38.00 59.00
C 38.50 59.00 39.58 59.18 40.00 59.00
C 40.03 58.65 40.71 57.94 41.00 58.00
C 40.15 52.05 33.41 49.28 29.00 46.00
C 27.79 45.10 26.56 44.48 26.00 43.00
C 25.17 40.82 38.28 28.34 41.00 25.00
C 41.80 24.02 42.09 24.65 43.00 24.00
C 49.45 19.39 55.03 11.53 60.00 6.00
C 64.01 11.53 67.71 17.62 73.00 22.00 Z'
          />
        </g>
        <g fill='#4B51A2' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 43.00 24.00 
C 44.55 24.27 45.89 27.09 47.00 28.00
C 52.93 31.61 55.22 35.23 59.00 40.00
C 59.27 39.94 59.90 40.75 61.00 40.00
C 64.33 34.54 70.27 31.03 74.00 26.00
C 71.26 28.47 61.97 29.99 59.00 35.00
C 59.00 28.67 59.00 22.33 59.00 16.00
C 63.84 16.88 68.18 24.41 73.00 22.00
C 67.71 17.62 64.01 11.53 60.00 6.00
C 55.03 11.53 49.45 19.39 43.00 24.00 Z'
          />
        </g>
        <g fill='#9599CC' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 74.00 26.00 
C 75.23 25.72 76.27 24.28 76.00 23.00
C 74.95 23.01 73.78 22.74 73.00 22.00
C 68.18 24.41 63.84 16.88 59.00 16.00
C 59.00 22.33 59.00 28.67 59.00 35.00
C 61.97 29.99 71.26 28.47 74.00 26.00 Z'
          />
        </g>
        <g fill='#A0A4CE' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 41.00 25.00 
C 40.96 25.24 43.79 26.80 44.00 27.00
C 43.91 26.96 46.05 27.42 47.00 28.00
C 45.89 27.09 44.55 24.27 43.00 24.00
C 42.09 24.65 41.80 24.02 41.00 25.00 Z'
          />
        </g>
        <g fill='#4B52A3' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 70.00 33.00 
C 68.37 34.63 62.71 39.18 62.00 41.00
C 60.36 46.76 78.36 49.96 77.00 59.00
C 78.93 57.65 81.47 55.67 83.00 54.00
C 83.68 53.10 84.29 51.94 85.00 51.00
C 86.56 48.93 88.62 47.13 90.00 45.00
C 85.54 46.18 81.77 49.33 78.00 52.00
C 78.00 46.00 78.00 40.00 78.00 34.00
C 81.94 36.46 86.81 41.25 91.00 40.00
C 85.79 35.77 82.70 27.42 77.00 24.00
C 77.19 28.05 72.79 30.62 70.00 33.00 Z'
          />
        </g>
        <g fill='#484FA1' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 26.00 43.00 
C 26.23 43.44 28.58 45.62 29.00 46.00
C 33.41 49.28 40.15 52.05 41.00 58.00
C 41.05 58.35 41.88 58.74 42.00 59.00
C 44.33 54.23 50.72 48.04 55.00 45.00
C 51.44 46.37 44.63 48.67 41.00 53.00
C 41.00 46.67 41.00 40.33 41.00 34.00
C 45.84 34.88 50.18 42.41 55.00 40.00
C 50.02 37.12 48.01 30.78 44.00 27.00
C 43.79 26.80 40.96 25.24 41.00 25.00
C 38.28 28.34 25.17 40.82 26.00 43.00 Z'
          />
        </g>
        <g fill='#E8E9F4' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 44.00 27.00 
C 48.01 30.78 50.02 37.12 55.00 40.00
C 58.53 40.47 55.82 40.77 59.00 40.00
C 55.22 35.23 52.93 31.61 47.00 28.00
C 46.05 27.42 43.91 26.96 44.00 27.00 Z'
          />
        </g>
        <g fill='#BFC2DF' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 62.00 41.00 
C 62.71 39.18 68.37 34.63 70.00 33.00
C 67.81 34.87 62.86 37.99 62.00 41.00 Z'
          />
        </g>
        <g fill='#969ACC' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 55.00 45.00 
C 56.37 44.02 57.69 43.73 59.00 43.00
C 59.13 42.65 59.75 41.92 60.00 42.00
C 59.79 41.93 60.93 40.12 61.00 40.00
C 59.90 40.75 59.27 39.94 59.00 40.00
C 55.82 40.77 58.53 40.47 55.00 40.00
C 50.18 42.41 45.84 34.88 41.00 34.00
C 41.00 40.33 41.00 46.67 41.00 53.00
C 44.63 48.67 51.44 46.37 55.00 45.00 Z'
          />
        </g>
        <g fill='#979BCC' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 85.00 51.00 
C 88.18 48.20 92.73 45.13 94.00 41.00
C 92.98 40.99 91.74 40.76 91.00 40.00
C 86.81 41.25 81.94 36.46 78.00 34.00
C 78.00 40.00 78.00 46.00 78.00 52.00
C 81.77 49.33 85.54 46.18 90.00 45.00
C 88.62 47.13 86.56 48.93 85.00 51.00 Z'
          />
        </g>
        <g fill='#EE4726' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 22.00 45.00 
C 20.36 46.78 18.81 48.46 17.00 50.00
C 13.25 53.23 8.44 57.28 6.00 61.00
C 9.34 61.21 11.44 64.10 14.00 66.00
C 15.96 67.46 18.06 68.56 20.00 70.00
C 21.03 70.77 22.78 71.56 23.00 73.00
C 23.15 73.96 23.30 75.76 22.00 76.00
C 24.70 78.13 26.57 73.31 29.25 70.25 C 31.93 67.18 34.83 64.42 38.00 62.00
C 34.16 63.46 27.28 66.17 23.00 70.00
C 23.00 63.67 23.00 57.33 23.00 51.00
C 27.40 54.37 31.53 57.93 37.00 59.00
C 36.49 58.75 36.32 57.35 36.00 57.00
C 30.67 53.03 28.62 45.84 23.00 42.00
C 22.27 42.49 22.39 44.57 22.00 45.00 Z'
          />
        </g>
        <g fill='#EE4725' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 59.00 43.00 
C 58.78 43.59 58.31 44.49 58.00 45.00
C 56.70 47.14 54.79 48.47 53.00 50.00
C 49.37 53.11 44.62 56.59 43.00 61.00
C 45.91 61.75 47.51 64.61 50.00 66.00
C 53.01 68.24 61.61 71.49 58.00 76.00
C 57.98 76.50 58.00 77.00 58.00 77.00
C 58.16 76.77 59.84 76.77 60.00 77.00
C 62.96 70.94 69.87 67.15 74.00 62.00
C 71.22 64.00 62.62 66.01 59.00 70.00
C 59.00 64.00 59.00 58.00 59.00 52.00
C 64.21 53.76 68.00 59.01 74.00 59.00
C 72.10 56.55 68.45 52.80 66.75 50.25 C 65.05 47.70 62.29 43.11 60.00 42.00
C 59.75 41.92 59.13 42.65 59.00 43.00 Z'
          />
        </g>
        <g fill='#EE4927' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 80.00 58.00 
C 79.77 58.25 79.17 59.92 79.00 60.00
C 80.59 61.02 82.28 62.75 84.00 64.00
C 86.92 66.13 86.88 68.02 90.75 69.25 C 94.62 70.48 93.33 74.49 94.00 76.00
C 96.72 78.15 99.00 72.87 101.75 69.75 C 104.50 66.63 107.52 64.27 110.00 61.00
C 105.69 64.36 99.00 65.68 95.00 70.00
C 95.00 64.00 95.00 58.00 95.00 52.00
C 100.38 53.58 103.93 58.85 110.00 59.00
C 104.96 54.32 100.38 48.08 97.00 42.00
C 91.95 46.64 85.17 52.46 80.00 58.00 Z'
          />
        </g>
        <g fill='#838EC6' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 29.00 46.00 
C 28.58 45.62 26.23 43.44 26.00 43.00
C 26.56 44.48 27.79 45.10 29.00 46.00 Z'
          />
        </g>
        <g fill='#F2F3F1' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 55.00 45.00 
C 50.72 48.04 44.33 54.23 42.00 59.00
C 41.80 59.40 42.00 60.00 42.00 60.00
C 45.69 64.84 49.60 73.03 55.00 76.00
C 55.89 76.49 57.28 76.55 58.00 77.00
C 58.00 77.00 57.98 76.50 58.00 76.00
C 58.06 74.19 52.28 68.47 50.00 66.00
C 47.51 64.61 45.91 61.75 43.00 61.00
C 44.62 56.59 49.37 53.11 53.00 50.00
C 54.55 48.45 56.57 46.54 58.00 45.00
C 58.31 44.49 58.78 43.59 59.00 43.00
C 57.69 43.73 56.37 44.02 55.00 45.00 Z'
          />
        </g>
        <g fill='#F6A45E' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 17.00 50.00 
C 18.81 48.46 20.36 46.78 22.00 45.00
C 20.30 46.54 18.65 48.35 17.00 50.00 Z'
          />
        </g>
        <g fill='#F9B578' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 53.00 50.00 
C 54.79 48.47 56.70 47.14 58.00 45.00
C 56.57 46.54 54.55 48.45 53.00 50.00 Z'
          />
        </g>
        <g fill='#F89D5D' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 38.00 62.00 
C 38.72 61.45 39.82 61.15 40.00 60.00
C 40.07 59.51 40.00 59.00 40.00 59.00
C 39.58 59.18 38.50 59.00 38.00 59.00
C 37.50 59.00 37.00 59.00 37.00 59.00
C 31.53 57.93 27.40 54.37 23.00 51.00
C 23.00 57.33 23.00 63.67 23.00 70.00
C 27.28 66.17 34.16 63.46 38.00 62.00 Z'
          />
        </g>
        <g fill='#F79C5D' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 74.00 62.00 
C 76.14 59.34 75.58 61.04 74.00 59.00
C 68.00 59.01 64.21 53.76 59.00 52.00
C 59.00 58.00 59.00 64.00 59.00 70.00
C 62.62 66.01 71.22 64.00 74.00 62.00 Z'
          />
        </g>
        <g fill='#F79C5D' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 110.00 61.00 
C 111.74 58.71 112.01 61.30 110.00 59.00
C 103.93 58.85 100.38 53.58 95.00 52.00
C 95.00 58.00 95.00 64.00 95.00 70.00
C 99.00 65.68 105.69 64.36 110.00 61.00 Z'
          />
        </g>
        <g fill='#8FB0EB' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 77.00 59.00 
C 77.00 59.00 77.00 59.50 77.00 60.00
C 77.25 59.75 78.00 60.00 78.00 60.00
C 78.61 59.41 79.42 58.56 80.00 58.00
C 81.04 56.98 82.08 55.23 83.00 54.00
C 81.47 55.67 78.93 57.65 77.00 59.00 Z'
          />
        </g>
        <g fill='#F7A6A0' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 37.00 59.00 
C 37.00 59.00 37.50 59.00 38.00 59.00
C 38.42 58.16 36.38 57.30 36.00 57.00
C 36.32 57.35 36.49 58.75 37.00 59.00 Z'
          />
        </g>
        <g fill='#8F9DD8' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 40.00 59.00 
C 40.00 59.00 40.07 59.51 40.00 60.00
C 40.00 60.00 40.50 60.00 41.00 60.00
C 41.50 60.00 42.00 60.00 42.00 60.00
C 42.00 60.00 41.80 59.40 42.00 59.00
C 41.88 58.74 41.05 58.35 41.00 58.00
C 40.71 57.94 40.03 58.65 40.00 59.00 Z'
          />
        </g>
        <g fill='#FFBDAA' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 78.00 60.00 
C 78.00 60.00 78.60 60.20 79.00 60.00
C 79.17 59.92 79.77 58.25 80.00 58.00
C 79.42 58.56 78.61 59.41 78.00 60.00 Z'
          />
        </g>
        <g fill='#28AE4E' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 56.00 80.00 
C 52.18 81.41 45.48 84.56 41.00 88.00
C 41.00 82.00 41.00 76.00 41.00 70.00
C 45.84 70.88 50.18 78.41 55.00 76.00
C 49.60 73.03 45.69 64.84 42.00 60.00
C 42.00 60.00 41.50 60.00 41.00 60.00
C 37.54 66.54 30.47 71.74 25.00 77.00
C 27.13 85.28 43.42 85.84 40.00 96.00
C 45.78 92.01 49.90 84.66 56.00 80.00 Z'
          />
        </g>
        <g fill='#85DAA4' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 77.00 61.00 
C 77.74 61.81 79.25 62.29 80.00 63.00
C 79.38 62.16 78.81 60.73 78.00 60.00
C 78.00 60.00 77.25 59.75 77.00 60.00
C 77.00 60.00 77.16 60.56 77.00 61.00 Z'
          />
        </g>
        <g fill='#000000' fillOpacity='0.00' stroke='None'>
          <path
            d='
M 0.00 120.00 
L 59.00 120.00
C 39.88 100.05 20.00 80.17 0.00 61.00
L 0.00 120.00 Z'
          />
        </g>
        <g fill='#2AAF4F' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 60.00 78.00 
C 59.60 78.20 59.00 78.00 59.00 78.00
C 58.74 84.80 42.51 90.22 43.25 96.75 C 43.98 103.29 63.78 104.38 58.00 114.00
C 64.23 109.86 68.30 101.68 75.00 97.00
C 75.23 96.84 75.00 96.00 75.00 96.00
C 69.10 97.65 64.59 103.66 59.00 106.00
C 59.00 100.00 59.00 94.00 59.00 88.00
C 63.84 88.88 68.18 96.41 73.00 94.00
C 68.66 90.68 65.38 85.61 63.00 81.00
C 67.99 83.88 72.22 87.82 77.00 91.00
C 77.27 92.60 74.57 94.99 77.00 96.00
C 80.46 93.62 82.44 90.24 85.00 87.00
C 86.55 85.04 88.17 83.56 90.00 82.00
C 91.68 81.25 93.04 79.57 94.00 78.00
C 87.91 74.83 84.01 68.45 80.00 63.00
C 79.25 62.29 77.74 61.81 77.00 61.00
C 75.16 66.09 65.02 75.54 60.00 78.00
M 92.00 78.00 
C 88.01 82.80 81.54 84.63 77.00 89.00
C 77.00 82.67 77.00 76.33 77.00 70.00
C 82.44 71.73 85.94 77.46 92.00 78.00 Z'
          />
        </g>
        <g fill='#000000' fillOpacity='0.00' stroke='None'>
          <path
            d='
M 61.00 120.00 
L 120.00 120.00
L 120.00 61.00
C 100.05 80.12 80.17 100.00 61.00 120.00 Z'
          />
        </g>
        <g fill='#FCCFA4' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 94.00 76.00 
C 93.33 74.49 94.62 70.48 90.75 69.25 C 86.88 68.02 86.92 66.13 84.00 64.00
C 87.79 67.50 91.49 74.02 94.00 76.00 Z'
          />
        </g>
        <g fill='#FCCFA3' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 22.00 76.00 
C 23.30 75.76 23.15 73.96 23.00 73.00
C 23.00 73.00 20.15 70.14 20.00 70.00
C 18.06 68.56 15.96 67.46 14.00 66.00
C 16.91 69.15 20.03 74.44 22.00 76.00 Z'
          />
        </g>
        <g fill='#FCCEA2' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 58.00 76.00 
C 61.61 71.49 53.01 68.24 50.00 66.00
C 52.28 68.47 58.06 74.19 58.00 76.00 Z'
          />
        </g>
        <g fill='#F79351' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 23.00 73.00 
C 22.78 71.56 21.03 70.77 20.00 70.00
C 20.15 70.14 23.00 73.00 23.00 73.00 Z'
          />
        </g>
        <g fill='#96CC79' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 56.00 80.00 
C 56.72 79.45 57.82 79.15 58.00 78.00
C 58.07 77.51 58.00 77.00 58.00 77.00
C 57.28 76.55 55.89 76.49 55.00 76.00
C 50.18 78.41 45.84 70.88 41.00 70.00
C 41.00 76.00 41.00 82.00 41.00 88.00
C 45.48 84.56 52.18 81.41 56.00 80.00 Z'
          />
        </g>
        <g fill='#96CC77' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 92.00 78.00 
C 85.94 77.46 82.44 71.73 77.00 70.00
C 77.00 76.33 77.00 82.67 77.00 89.00
C 81.54 84.63 88.01 82.80 92.00 78.00 Z'
          />
        </g>
        <g fill='#FBAAA1' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 58.00 78.00 
C 58.00 78.00 58.50 78.00 59.00 78.00
C 59.00 78.00 59.60 78.20 60.00 78.00
C 60.00 78.00 59.80 77.40 60.00 77.00
C 59.84 76.77 58.16 76.77 58.00 77.00
C 58.00 77.00 58.07 77.51 58.00 78.00 Z'
          />
        </g>
        <g fill='#E7F2DF' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 73.00 94.00 
C 73.80 94.61 74.82 94.82 75.00 96.00
C 75.00 96.00 75.23 96.84 75.00 97.00
C 75.70 97.73 76.78 96.15 77.00 96.00
C 74.57 94.99 77.27 92.60 77.00 91.00
C 72.22 87.82 67.99 83.88 63.00 81.00
C 65.38 85.61 68.66 90.68 73.00 94.00 Z'
          />
        </g>
        <g fill='#9ADAAB' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 85.00 87.00 
C 86.42 85.47 88.46 83.54 90.00 82.00
C 88.17 83.56 86.55 85.04 85.00 87.00 Z'
          />
        </g>
        <g fill='#96CC78' fillOpacity='1.00' stroke='None'>
          <path
            d='
M 75.00 96.00 
C 74.82 94.82 73.80 94.61 73.00 94.00
C 68.18 96.41 63.84 88.88 59.00 88.00
C 59.00 94.00 59.00 100.00 59.00 106.00
C 64.59 103.66 69.10 97.65 75.00 96.00 Z'
          />
        </g>
      </svg>
    </div>
  );
};

export default Laurie;
